module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/personal-care-woman-banner_36a374.png";